export default __webpack_public_path__ + "static/media/default-headshot.5ad2de77.jpg";